module.exports = __webpack_public_path__ + "img/restaurant-10.e93d81dc.jpg";